// extracted by mini-css-extract-plugin
module.exports = {"navlink":"_navlink_navlink__DV8hx","active":"_navlink_active__p5ARC"};